import React from "react";
import Spinner from "react-bootstrap/Spinner";
export default function FallBack() {
  return (
    <div className="text-center">
      <Spinner />
    </div>
  );
}
